"use client";

import { ComponentProps } from "react";

type JavascriptButtonProps = {
  javascript: string;
} & ComponentProps<"button">;

const JavascriptButton = ({
  javascript,
  children,
  ...rest
}: JavascriptButtonProps) => {
  return (
    <button {...rest} onClick={() => eval(javascript)}>
      {children}
    </button>
  );
};

export default JavascriptButton;
